// src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

// Context for theme management
import { useThemeMode, ThemeModeContext } from './theme/themeContext'; 

// --- 1. IMPORT YOUR NEW AUTH PROVIDER ---
import { AuthProvider } from './auth/AuthContext'; // Adjust path if needed

// Import your pages
import MainApp from './pages/MainApp';
import CustomDatingView from './pages/CustomDatingView';
import IdentityLibraryView from './pages/IdentityLibraryView';

function App() {
  const [theme, themeMode] = useThemeMode();

  return (
    // --- 2. WRAP EVERYTHING IN THE AUTHPROVIDER ---
    // This makes authentication state global.
    // The order of providers (Auth vs. Theme) doesn't typically matter.
    <AuthProvider>
      <ThemeModeContext.Provider value={themeMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <Routes>
              {/* Add a route for logging in */}
              {/* <Route path="/login" element={<LoginPage />} /> */}
              
              {/* Route to your main tool */}
              <Route path="/" element={<MainApp />} />

              {/* Route for the custom workflow ("Pro mode") */}
              <Route path="/custom" element={<CustomDatingView />} />

              {}
              <Route path="/library" element={<IdentityLibraryView />} />
              
            </Routes>
          </BrowserRouter>
        </ThemeProvider>
      </ThemeModeContext.Provider>
    </AuthProvider>
  );
}

export default App;